var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import TextField from '@mui/material/TextField';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from "@mui/x-date-pickers";
import { enqueueSnackbar } from "notistack";
import { errorSnackbar, successSnackbar } from "../../../../shared/snackbar-constants";
import { getErrorMessage } from "../../../../utilities/axios-utility";
dayjs.extend(utc);
export var MyAccountValidThrough = function (_a) {
    var validThrough = _a.validThrough, documentId = _a.documentId, setIsDataChange = _a.setIsDataChange, dateValidThrough = _a.dateValidThrough, documentsProvider = _a.documentsProvider;
    var _b = React.useState(dateValidThrough ? dayjs(dateValidThrough) : null), value = _b[0], setValue = _b[1];
    var _c = React.useState(null), error = _c[0], setError = _c[1];
    var minDate = dayjs(new Date()).utc();
    var maxDate = dayjs('2099-12-31T23:59:59.999').utc();
    var handleChange = function (newValue) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setValue(newValue);
                    if (!(newValue && newValue.isAfter(minDate) && newValue.isBefore(maxDate))) return [3 /*break*/, 2];
                    return [4 /*yield*/, setDateValidThrough(newValue)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var setDateValidThrough = function (date) { return __awaiter(void 0, void 0, void 0, function () {
        var model, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    model = {
                        LeadKycDocumentId: documentId,
                        validThrough: date.utc(true).toDate()
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, documentsProvider.SetValidThrough(model)];
                case 2:
                    _a.sent();
                    setIsDataChange(function (prevState) { return !prevState; });
                    enqueueSnackbar('Date changed', successSnackbar);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    enqueueSnackbar(getErrorMessage(error_1), errorSnackbar);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var errorMessage = React.useMemo(function () {
        switch (error) {
            case 'maxDate':
            case 'minDate':
            case 'invalidDate': {
                return 'Date is not valid';
            }
            default: {
                return '';
            }
        }
    }, [error]);
    return (_jsx("div", { children: validThrough ?
            _jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: _jsx(DatePicker, { label: "Select a date", inputFormat: 'DD.MM.YYYY', value: value, onError: function (newError) { return setError(newError); }, onChange: handleChange, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { inputProps: __assign({}, params.inputProps), helperText: errorMessage }))); }, minDate: minDate }) }))
            : 'N/A' }));
};
